var _path, _line, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 23L9 14L5.48284 14C5.30466 14 5.21543 13.7846 5.34142 13.6586L12 7L18.6586 13.6586C18.7846 13.7846 18.6953 14 18.5172 14L15 14L15 23",
    stroke: "#3C98FA",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 22,
    x2: 16,
    y2: 22,
    stroke: "#3C98FA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1L11.5 4",
    stroke: "url(#paint0_linear_1442_542)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6L17.5 7M3 6L5.5 7",
    stroke: "url(#paint1_linear_1442_542)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.5L15.5 4.5M6 2.5L7.5 4.5",
    stroke: "url(#paint2_linear_1442_542)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1442_542",
    x1: 12,
    y1: 0.999998,
    x2: 12,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CA4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DE4F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1442_542",
    x1: 11.5,
    y1: 6,
    x2: 11.5,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CA4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DE4F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1442_542",
    x1: 11.5,
    y1: 2.5,
    x2: 11.5,
    y2: 4.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CA4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DE4F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSparkle);
export default __webpack_public_path__ + "static/media/ArrowSparkle.15ea997489897c8c067ad5578f74af65.svg";
export { ForwardRef as ReactComponent };